import React from 'react';
import { Typography, Card, CardContent } from '@mui/material';
import { CollectionsBookmark as SessionsIcon } from '@mui/icons-material';

const ProfileEmptyState = ({ username }) => (
  <Card sx={{ overflow: 'hidden', '&:hover': { transform: 'none' } }}>
    <CardContent sx={{ textAlign: 'center', py: 5 }}>
      <SessionsIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1.5, opacity: 0.5 }} />
      <Typography variant="body1" color="text.secondary" fontWeight={500}>
        No shared sessions or projects yet
      </Typography>
      <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5 }}>
        @{username} hasn't published anything publicly yet.
      </Typography>
    </CardContent>
  </Card>
);

export default ProfileEmptyState;
